import { Component, OnInit } from '@angular/core';
import { SidebarService } from '@layout/core/services';
import { CurrentUserService } from '@core/services';
import { CurrentUser } from '@shared/interfaces';
import * as moment from 'moment';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss', './header-mobile.component.scss'],
})
export class HeaderComponent implements OnInit {
    isSidebarCollapsed = true;
    currentUser: CurrentUser | null = null;
    welcomeMessage = 'header.welcome';
    showWelcomeMessage : boolean;

    constructor(private sidebarService: SidebarService, private userService: CurrentUserService) {
        this.sidebarService.isCollapsed$.subscribe(isCollapsed => {
            this.isSidebarCollapsed = isCollapsed;
        });
        this.showWelcomeMessage = false;
    }

    async loadUser() : Promise<void>{
        this.userService.currentUser$.subscribe(user => {
            this.currentUser = user;
            if(this.currentUser != null){
                this.showWelcomeMessage = true;
            }
        });
        this.computeWelcomeMessage();

    }

    async ngOnInit() : Promise<void>{
        await this.loadUser();
    }

    computeWelcomeMessage(): void {
        const current = moment();
        const midnight = moment().set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
        const morning = moment().set({ hour: 11, minute: 59, second: 59, millisecond: 59 });
        const afternoon = moment().set({ hour: 15, minute: 59, second: 59, millisecond: 59 });
        const evening = moment().set({ hour: 23, minute: 59, second: 59, millisecond: 59 });

        if (current.isBetween(midnight, morning)) {
            this.welcomeMessage = 'header.goodMorning';
            return;
        }
        if (current.isBetween(morning, afternoon)) {
            this.welcomeMessage = 'header.goodAfternoon';
            return;
        }
        if (current.isBetween(afternoon, evening)) {
            this.welcomeMessage = 'header.goodEvening';
            return;
        }
    }
}
